module.exports = __webpack_public_path__ + "static/media/DoubleLeftOutlined.e6ab895d.svg";